import { createContext, useContext, useState, type ReactNode } from 'react';
import type { CateringService } from '../services/cateringService';

const CateringServiceContext = createContext<CateringService | undefined>(undefined);

export type CateringProviderProps = {
  children: ReactNode;
  service: CateringService;
};

export function CateringProvider({ children, service }: CateringProviderProps) {
  const [client] = useState<CateringService>(() => service);

  return (
    <CateringServiceContext.Provider value={client}>{children}</CateringServiceContext.Provider>
  );
}

export function useCateringService(): CateringService {
  const service = useContext(CateringServiceContext);
  if (!service) {
    throw new Error('useCateringService must be used within a CateringProvider.');
  }

  return service;
}
